module.exports = __webpack_public_path__ + "img/mail.16881f3.svg";